import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/ad4b4b45-2009-4d9d-817c-fd1a339746d4.jpg';
export function Hero() {
  const ref = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: ref,
    offset: ['start start', 'end start']
  });
  const imageY = useTransform(scrollYProgress, [0, 1], ['0%', '12%']);
  const contentOpacity = useTransform(scrollYProgress, [0, 0.6], [1, 0]);
  return <section id="top" ref={ref} className="relative h-[100svh] min-h-[560px] w-full overflow-hidden bg-blush" aria-label="PARṆA: yoga, breath and stillness" data-id="element-72" data-mp="xbpbb0flzqce">
      <motion.img src={HERO_IMAGE} alt="A symmetrical sunset over still water, the sun resting on the horizon and mirrored below" style={{
      y: imageY
    }} className="absolute inset-0 h-[112%] w-full object-cover object-center" data-id="element-73" data-mp="nb6mdr96tjnm" />
      <div className="absolute inset-x-0 top-0 h-32 bg-ink/[0.07]" aria-hidden="true" data-id="element-74" data-mp="3j8sd1u7lx7mo" />

      <motion.div style={{
      opacity: contentOpacity
    }} className="relative flex h-full flex-col items-center justify-end pb-16 text-center" data-id="element-75" data-mp="3o7ls3r2jl6oy">
        <motion.p initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.6,
        duration: 1.2,
        ease: [0.22, 1, 0.36, 1]
      }} className="max-w-prose px-8 font-display text-[1.7rem] font-light italic leading-snug text-white [text-shadow:0_2px_24px_rgba(90,58,52,0.55)] sm:text-[2rem]" data-id="element-76" data-mp="399tc6xt32ga8">
          Breathe in. The whole sky is yours.
        </motion.p>

        <motion.a href="#philosophy" aria-label="Scroll to the practice" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        delay: 1.2,
        duration: 1.4
      }} className="group mt-12 flex flex-col items-center" data-id="element-77" data-mp="2qi0kr7tnx34m">
          <span className="block h-12 w-px bg-white/50 transition-colors duration-500 group-hover:bg-white" aria-hidden="true" data-id="element-78" data-mp="2lmv16fnqg0jp" />
        </motion.a>
      </motion.div>
    </section>;
}